<template>
    <div class="partner">
        <div class="header_btn">
            <el-button type="primary" :icon="Plus" @click="addBtn">添加</el-button>
        </div>
        <div class="count">统计：{{ count }}条</div>

        <el-table :data="filterTableData" :header-cell-style="{ background: '#F5F7FA' }" :empty-text="texts"
            v-loading="showLoading" style="width: 100%;" row-key="id" border
            :tree-props="{ children: 'subCategories' }">
            <el-table-column fixed label="记录ID" prop="id" align="center" :show-overflow-tooltip='true' width="250" />
            <!-- 类目ID -->
            <el-table-column label="类目ID" prop="categoryId" align="center" 
                :show-overflow-tooltip='true'></el-table-column>
            <!-- 类目名称 -->
            <el-table-column label="类目名称" prop="categoryName" align="center" :show-overflow-tooltip='true'
                width="200"></el-table-column>
            <!-- 状态 -->
            <el-table-column label="状态" prop="state" align="center" :show-overflow-tooltip='true' width="100">
                <template #default="scope">
                    <el-tag type="success" v-show="scope.row.state == 1">启用</el-tag>
                    <el-tag type="danger" v-show="scope.row.state == 2">未启用</el-tag>
                </template>
            </el-table-column>
            <!-- 图标 -->
            <el-table-column label="图标" align="center" :show-overflow-tooltip='true' width="200">
                <template #default="scope">
                    <!-- 检查当前行是否为子级数据且有图标链接 -->
                    <template v-if="isChildData(scope.row) && scope.row.iconLink">
                        <el-image style="width: 50px; height: 50px" :src="scope.row.iconLink"
                            fit="cover" :preview-src-list="[scope.row.iconLink]" preview-teleported
                            hide-on-click-modal />
                    </template>
                    <!-- 若子级数据图标链接不存在，显示 '-' -->
                    <template v-else-if="isChildData(scope.row)">
                        -
                    </template>
                    <!-- 一级数据显示 '-' -->
                    <template v-else>
                        -
                    </template>
                </template>
            </el-table-column>
            <!-- 排序 -->
            <el-table-column label="排序" prop="sort" align="center" :show-overflow-tooltip='true'
                width="120"></el-table-column>
            <!-- 创建时间 -->
            <el-table-column label="创建时间" prop="createTime" align="center" :show-overflow-tooltip='true' width="200"
                :formatter="reach">
            </el-table-column>
            <!-- 毛利率 -->
            <el-table-column label="毛利率" prop="grossMargin" align="center" :show-overflow-tooltip='true' width="100">
                <template #default="scope">
                    <span>{{ scope.row.grossMargin ? scope.row.grossMargin + '%' : '' }}</span>
                </template>
            </el-table-column>
               <!-- 映射平台类目 -->
            <el-table-column label="映射平台类目" prop="platformCategoryName" align="center" :show-overflow-tooltip='true' width="200"
                >
            </el-table-column>
            <!-- 操作 -->
            <el-table-column label="操作" align="center" width="150" :show-overflow-tooltip='true'>
                <template #default="scope">
                    <el-button size="default" class="bulur" @click="editPartner(scope.row)">
                        <el-icon>
                            <EditPen />
                        </el-icon>编辑
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script setup>
import { Plus, EditPen } from '@element-plus/icons-vue'
import { ref, onMounted } from 'vue';
import moments from 'moment'
import {
    wangyiPlatformCategoryData,
} from "../../../../request/api";
import {
    useRouter,
} from "vue-router";
const router = useRouter()
// 表格数据
const filterTableData = ref([]);
// 总计条数
const count = ref(0);
const showLoading = ref(true); //加载loading

// 表格数据方法
const dataInfo = () => {
    wangyiPlatformCategoryData().then((res) => {
        if (res.data.code == 0) {
            showLoading.value = false;
            filterTableData.value = res.data.data.categoryList;
            count.value = res.data.data.categoryList.length;
        }
    })
}

// 定义 reach 方法
const reach = (row, column, cellValue) => {
    if (cellValue) {
        return moments(cellValue * 1000).format("YYYY-MM-DD HH:mm")
    }
    return '';
};

// 跳转添加
const addBtn = () => {
    router.push({ path: '/platform/add' })
}

// 跳转编辑
const editPartner = (item) => {
    let dataType = 'parent'; // 默认是一级数据
    // 查找是否为子级数据
    const findParent = (parentList) => {
        for (const parent of parentList) {
            if (parent.subCategories && parent.subCategories.some(child => child.id === item.id)) {
                dataType = 'child';
                return true;
            }
            if (parent.subCategories && findParent(parent.subCategories)) {
                return true;
            }
        }
        return false;
    };
    findParent(filterTableData.value);
    sessionStorage.setItem('wangyiDataType', dataType); // 存储数据类型
    sessionStorage.setItem('categoryId', item.categoryId);
    router.push({ path: '/wangyi/platform/edit' });
};

onMounted(() => {
    dataInfo()
})

// 判断是否为子级数据
const isChildData = (row) => {
    const findParent = (parentList) => {
        for (const parent of parentList) {
            if (parent.subCategories?.some(child => child.id === row.id)) {
                return true;
            }
            if (parent.subCategories && findParent(parent.subCategories)) {
                return true;
            }
        }
        return false;
    };
    return findParent(filterTableData.value);
};
</script>

<style lang="scss" scoped>
.bulur {
    color: #409eff;
    border: none;
    --el-button-bg-color: none;
    --el-button-hover-bg-color: none;
    --el-button-hover-text-color: none;
}

.bulur:hover {
    color: #a0cfff;
}

.partner {
    height: calc(100vh - 170px);
    background-color: #FFFFFF;
    width: 95%;
    padding: 20px;
    overflow: auto;
    box-shadow: var(--el-box-shadow-light);
    border-radius: 5px;
    margin: 15px auto;
}

.header_btn {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
}

.count {
    font-size: 14px;
    color: #909399;
    margin-bottom: 15px;
}
</style>